import { Endpoints } from "@/api/ApiEndpoints";
import { formatDate } from "@/core/helpers/DatetimeConverter";

const TournamentPointsMap = {
  Plural: "Tournament Points",
  Single: "Tournament Point",
  ModalForm: false,
  DefaultSorting: "pointsAddedDate",
  DefaultSortingType: "desc",
  Columns: [
    { name: "", label: "#", type: "counter" },
    {
      name: "tournamentName",
      dbName: "tournamentName",
      label: "Tournament",
      type: "text",
      format: (row: any) => row.tournamentName ?? "—",
    },
    {
      name: "nickName",
      dbName: "user.nickName",
      label: "User",
      type: "text",
      format: (row: any) => row.user?.nickName ?? "—",
    },
    {
      name: "points",
      dbName: "points",
      label: "Points",
      type: "text",
    },
    {
      name: "reason",
      dbName: "reason",
      label: "Reason",
      type: "text",
    },
    {
      name: "couponId",
      dbName: "couponId",
      label: "Coupon",
      type: "text",
      format: (row: any) =>
        row.couponId
          ? `<a href="/coupons/list?pageNumber=1&SearchTerm=${row.couponId}">#${row.couponId}</a>`
          : "—",
    },
    {
      name: "pointsAddedDate",
      dbName: "pointsAddedDate",
      label: "Points Added",
      sortable: true,
      type: "date",
      format: (row: any) => formatDate(row.pointsAddedDate),
    },
  ],
  Filters: [
    {
      name: "Tournaments",
      label: "Tournament",
      nameToRequest: "TournamentId",
      endpoint: Endpoints.TOURNAMENTS_FOR_FILTERS,
      type: "groupedSelect",
      attributes: {
        name: "name",
        linkedAttr: "id",
      },
      mapping: (tournamentsFromResponse: any) => {
        return tournamentsFromResponse;
      },
    },
    {
      name: "User",
      label: "User",
      nameToRequest: "SearchTerm",
      type: "text",
      valueType: "text",
    },
  ],
  PrimaryKey: "id",
  Actions: {}, // read-only list
};

export default TournamentPointsMap;
